<script>
  import get from 'lodash/get'

  export default {
    name: 'PrismicImage',
    render (h) {
      if (typeof this.url !== 'string' || !this.url.length) return null

      return (
        <img alt={this.alt} className="cms-image" src={this.url} />
      )
    },
    props: {
      field: {
        default: () => {},
        type: Object,
      },
    },
    computed: {
      alt () {
        return get(this.field, 'alt', null)
      },
      url () {
        return get(this.field, 'url', null)
      },
    },
  }
</script>
